/** 能源 — 用水报表 /energy/water-report（waterReport.vue） */
export default {
  waterReport: {
    dashboardTitle: '用水报表',
    tabStatistics: '租户用水统计',
    tabDetail: '租户用水明细',
    exportLoading: '导出中...',
    exportReport: '导出报表',
    filterStatPeriod: '统计时间',
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    filterTenant: '选择租户',
    phTenant: '请选择租户',
    filterTenantType: '租户类型',
    tenantType0: '租户',
    tenantType1: '公区',
    tenantType2: '其他',
    tenantType3: '光伏',
    btnReset: '重置',
    btnSelectAll: '全选',
    btnDeselectAll: '取消全选',
    tooltipDeviceDetail: '设备明细为单租户数据；当前为「全部」时将自动选用列表第一个租户',
    tooltipDetailDeviceDetail: '查看所选租户的设备明细数据',
    deviceDetailSwitch: '设备明细',
    loadingText: '数据加载中...',
    chartTrendTitle: '用水趋势分析',
    legendTotalFee: '总水费',
    legendTotalWater: '总水量',
    summaryTotalFee: '总水费',
    summaryTotalWater: '总水量',
    detailedData: '详细数据',
    sectionDetailTitle: '租户用水明细',
    sectionDeviceDetailTitle: '租户设备用水明细',
    colDate: '日期',
    colWaterFeeYuan: '水费（元）',
    colWaterVolumeM3: '水量（m³）',
    colDevice: '设备',
    colSettleWay: '结算方式',
    colFee: '费用',
    colTime: '时间',
    colCumulativeRead: '累计读数',
    colStartReading: '起始读数',
    colEndReading: '截止读数',
    emptyNoData: '暂无数据',
    emptyNoDeviceDetail: '暂无设备明细数据',
    colTenantId: '租户编号',
    colTenantName: '租户名称',
    colWaterMeter: '水表',
    colDetail: '明细',
    colStatistics: '统计',
    colWaterFeeParen: '水费(元)',
    colWaterVolumeParen: '水量(m³)',
    tenantAll: '全部',
    summaryTotal: '总计',
    dateSpan100Days: '100天',
    dateSpan1Year: '1年',
    msgDateRangeLimit: '最多只能选择{span}的数据',
    msgTenantListFail: '获取租户列表失败',
    msgPickPeriod: '请选择统计时间',
    msgPickTenant: '请选择租户',
    msgNoTenantData: '暂无租户数据',
    msgFetchFail: '获取数据失败',
    msgExportEmpty: '暂无数据可导出',
    msgExportEmptyDevice: '暂无设备明细数据可导出',
    msgExportOk: '导出成功！',
    msgExportFail: '导出失败',
    msgExportRetry: '请重试',
    msgDeviceAutoTenant: '设备明细模式已自动选择第一个租户',
    msgNoTenantAvailable: '暂无可用租户',
    errNoDeviceExport: '没有可导出的设备明细数据',
    errNoTenantMeterExport: '没有可导出的租户水表明细数据',
    expFilterTime: '统计时间: {start} 至 {end}',
    expFilterTenant: '租户: {tenant}',
    expFilterDeviceDetail: '设备明细',
    expColDate: '日期',
    expColWaterFee: '水费（元）',
    expColWaterVolume: '水量（m³）',
    expColDevice: '设备',
    expColSettleWay: '结算方式',
    expColFee: '费用',
    expColRegion: '区域标签',
    expColTenantId: '租户编号',
    expColTenantName: '租户名称',
    expColWaterMeter: '水表',
    expSheetStat: '租户用水统计',
    expSheetStatDevice: '租户用水统计-设备明细',
    expSheetDetail: '租户用水明细',
    expSheetDetailDevice: '租户用水明细-设备明细',
    listSep: '、',
    seriesTotalFee: '总水费',
    seriesTotalWater: '总水量',
    yAxisWaterFee: '水费 (元)',
    yAxisWaterVolume: '水量 (m³)',
    unitYuan: '元',
    settleWay0: '普通结算',
    settleWay1: '手动扣款',
    settleWay2: '系统补单',
    settleWay3: '浮动电价',
    settleWay4: '分摊结算',
    settleWay5: '设备扣款',
    pickerYesterday: '昨天',
    pickerThisWeek: '本周',
    pickerLastWeek: '上周',
    pickerThisMonth: '本月',
    pickerLastMonth: '上月',
    pickerLast3Months: '近三个月',
    pickerLastYear: '近一年'
  }
}
